<script>
import { Bar } from "vue-chartjs";

export default {
  props : {
      labels:{
          type:Array,
          default: () => [],
      },
      data:{
          type:Array,
          default: () => [],
      },
      colors:{
          type:Array,
          default: () => [],
      },
  },
  extends: Bar,
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            barPercentage: 0.2,
            label: "Nombre de Commandes",
            backgroundColor: this.colors,
            borderColor: this.colors,
            borderWidth: 1,
            hoverBackgroundColor: this.colors,
            hoverBorderColor: this.colors,
            data: this.data,
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                color: "rgba(166, 176, 207, 0.1)"
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                color: "rgba(166, 176, 207, 0.1)",
              },
              ticks: {
                beginAtZero: true
              },
            }
          ]
        },
        legend: {
					display: false
				},
      }
    );
  }
};
</script>